import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { List } from "../../types";
import { listEmojiOrDefault } from "../../constants/defaults";

export async function fetchLists(): Promise<List[]> {
  const { data, error } = await supabase
    .from("lists")
    .select("*")
    .order("order_position", { ascending: true });
  if (error) throw error;
  return ((data ?? []) as List[]).map((list) => ({
    ...list,
    emoji: listEmojiOrDefault(list.emoji),
  }));
}

export function useLists() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.lists,
    queryFn: fetchLists,
    enabled: !!user,
  });
}
